$(document).ready(function(){
  // Post-login redirect: send the customer back to where they were.
  // Domain-relative so the same code works on ca. and us.throatthreads.com.
  var checkout_url = function(){
      var location_href = location.href;
      if(window.location.pathname == "/account/login"){
        var urlParams = new URLSearchParams(window.location.search);
        location_href = urlParams.get('checkout_url') || '/';
      }
      $('.login-screen').find('#customer form').find('[name="checkout_url"]').val(location_href);
  }

  if($('.login-screen').is(':visible')){
    checkout_url();
  }

  // Re-apply briefly in case the login form re-renders, then stop (was: ran forever).
  var checkoutUrlTries = 0;
  var checkoutUrlInterval = setInterval(function(){
    checkout_url();
    checkoutUrlTries++;
    if(checkoutUrlTries >= 100){ clearInterval(checkoutUrlInterval); }
  }, 100);


  // ATC
$('#atc-btn').on('click', function(e){
  e.preventDefault();

  var $btn = $(this);
  // Guard against double-clicks: one submission at a time.
  if ($btn.hasClass('atc-busy')) { return; }
  $btn.addClass('atc-busy disabled').css({'pointer-events':'none','opacity':'0.6'});
  var atcDone = function(){
    $btn.removeClass('atc-busy disabled').css({'pointer-events':'auto','opacity':'1'});
  };

  var form = $(this).closest('form');
  var data = []; // fresh per click — never accumulate across clicks
  var seen = {};

  // Read EVERY cell that maps to a variant — not just the ones the buyer happened
  // to touch this visit. Quantity inputs are pre-filled from the cart on page load
  // (and every cell is de-selected again after a successful add), so gating
  // submission on a .selected class made the button a SILENT no-op for anyone
  // whose sizes were already in their cart. Untouched cells are harmless: they
  // match the cart and diff to nothing below, so nothing is sent for them.
  $('.v-table-col-main').each(function(){
    var th = $(this);
    var inseam = $('.input-row').find('.in-seam, .inseam');
    var $wrap = (inseam.length === 0) ? th.find('.data-wrap') : th.find('.data-wrap.inseam');
    var id = $wrap.attr('data-variant');
    if (!id || seen[id]) { return; } // size not offered in this colourway
    seen[id] = true;
    data.push({ id: id, quantity: Number($('#quantity-' + id).val()) || 0 });
  });

  if (!data.length) { atcDone(); return; }

  $.getJSON('/cart.js', function(cart) {
    const cartItems = cart.items;
    const updateData = [];
    const addData = [];



    data.forEach(item => {
      const cartItem = cartItems.find(ci => ci.variant_id === Number(item.id));
      if (cartItem) {
        // Only send a REAL change. An untouched cell already matches the cart,
        // so it diffs to nothing and is never transmitted.
        if (cartItem.quantity !== item.quantity) {
          updateData.push({
            id: cartItem.key, // full line item key (variant_id:hash)
            quantity: item.quantity // 0 is intentional: removes the line
          });
        }
      } else if (item.quantity > 0) {
        addData.push(item); // new item to add — never send qty 0 to /cart/add.js
      }
    });

    const updatesObj = Object.fromEntries(updateData.map(u => [u.id, u.quantity]));

    // Nothing to change (e.g. only zero-qty cells that were never in the cart):
    // don't show a false success message.
    if (!Object.keys(updatesObj).length && !addData.length) {
      // Tell the truth about WHY nothing moved: "already in your cart" and
      // "you picked nothing" are very different messages to a buyer.
      var wantedUnits = data.reduce(function(n, it){ return n + it.quantity; }, 0);
      $('.cart-message').html(wantedUnits > 0
        ? '<span class="cart-message__check">\u2713</span> Already in your cart at these quantities <a href="/cart">View cart</a>'
        : 'No quantities selected — nothing was added.');
      $('.cart-message').stop(true, true).fadeIn(150).delay(4500).fadeOut(300);
      atcDone();
      return;
    }

    let promise = Promise.resolve();

    // dataType:'json' is REQUIRED. Shopify returns cart JSON with
    // Content-Type: text/javascript, so a bare $.post lets jQuery "intelligently
    // guess" script and globalEval the JSON body — throwing a SyntaxError that
    // rejects the chain and skips the buyer's confirmation.
    if (Object.keys(updatesObj).length) {
      promise = promise.then(() => {
        return $.ajax({ url: '/cart/update.js', type: 'POST', dataType: 'json',
                        data: { updates: updatesObj } });
      });
    }

    if (addData.length) {
      promise = promise.then(() => {
        return $.ajax({ url: '/cart/add.js', type: 'POST', dataType: 'json',
                        data: { items: addData } });
      });
    }

    promise.then(() => {
      // Feedback where the eyes are: the button itself confirms, then reverts.
      var originalLabel = $btn.attr('data-add-to-cart-text') || 'Add to cart';
      $btn.addClass('atc-added').text('✓ Added to cart');
      setTimeout(function(){ $btn.removeClass('atc-added').text(originalLabel); }, 3200);

      // Toast is immediate (not gated on another request) — bottom-right, clear of the header.
      $('.cart-message').html('<span class="cart-message__check">✓</span> Cart updated <a href="/cart">View cart</a>');
      $('.cart-message').stop(true, true).fadeIn(150).delay(4500).fadeOut(300);

      // badge refresh in the background
      $.getJSON('/cart.js', function(cart) {
        if ($('.cart-link__count').length) {
          $('.cart-link__count').html(cart.item_count);
        } else {
          $('.cart-link__icon').append('<span class="cart-link__count">' + cart.item_count + '</span>');
        }
      });

      // ✅ Do NOT reset quantities — but re-baseline so cell states reflect the new cart
      $('.v-table-col-main.selected').removeClass('selected');
      $('.product-detail .data-wrap .quantity-input').each(function(){
        $(this).attr('data-initial', parseInt($(this).val()) || 0);
        syncCellState($(this).closest('.data-wrap'));
      });

      atcDone();
    }).catch(xhr => {
      let errorMessage = 'Something went wrong. Please try again.';
      try {
        const errorData = JSON.parse(xhr.responseText);
        if (errorData.message) {
          errorMessage = errorData.message;
        }
      } catch (e) {
        console.warn('Failed to parse error response:', e);
      }

      $('.cart-message').html('<span class="error">' + errorMessage + '</span>');
      $('.cart-message').fadeIn().delay(5000).fadeOut();

      atcDone();
    });
  }).fail(function(){
    atcDone();
  });
});
  // ---- shared cell-state helpers (PDP + cart) ----
  // State classes live on .v-table-data (the element that owns the visible
  // border) so we restyle ONE ring — layering a second inner ring on
  // .data-wrap read as a rendering glitch.
  function cellBox($wrap){
    var $box = $wrap.closest('.v-table-data');
    return $box.length ? $box : $wrap;
  }
  function flashMax($wrap){
    var $box = cellBox($wrap);
    $box.addClass('cell-max');
    setTimeout(function(){ $box.removeClass('cell-max'); }, 1200);
  }
  function syncCellState($wrap){
    var $input = $wrap.find('.quantity-input');
    var qty = parseInt($input.val()) || 0;
    var initial = parseInt($input.attr('data-initial')) || 0;
    $wrap.toggleClass('has-qty', qty > 0); // kept for any legacy selectors
    cellBox($wrap).toggleClass('cell-filled', qty > 0)
                  .toggleClass('cell-remove', qty === 0 && initial > 0);
  }
  // remember starting quantities (cells pre-filled from the cart) + initial visual state
  $('.data-wrap').each(function(){
    var $input = $(this).find('.quantity-input');
    if ($input.length) {
      $input.attr('data-initial', parseInt($input.val()) || 0);
      syncCellState($(this));
    }
  });

  // ---- PDP running order summary ("7 units · $834.40") ----
  function recalcOrderSummary(){
    var $s = $('[data-order-summary]');
    if (!$s.length) return;
    var units = 0, cents = 0;
    $('.product-detail .v-table-main .data-wrap').each(function(){
      var q = parseInt($(this).find('.quantity-input').val()) || 0;
      if (q > 0) { units += q; cents += q * (parseInt($(this).attr('data-price')) || 0); }
    });
    $s.find('.order-summary__units').text(units + (units === 1 ? ' unit' : ' units') + ' selected');
    var money = '';
    if (units > 0 && window.Shopify && Shopify.formatMoney) {
      money = Shopify.formatMoney(cents, $('body').attr('data-mf'));
    }
    $s.find('.order-summary__total').text(money);
  }
  recalcOrderSummary();

  // qty adjustments — PDP grid only (the cart grid has its own AJAX handler below)
  $('.product-detail .qtybox .btnqty').on('click', function () {
  var $qtyBox = $(this).parent('.qtybox');
  var $input = $qtyBox.find('.quantity-input');
  var $dataWrap = $(this).closest('.data-wrap');
  var $invNum = $dataWrap.find('.inv-num');
  if (!$invNum.length) { $invNum = $dataWrap.find('.inv-qty'); }
  var $plusBtn = $qtyBox.find('.qtyplus');

  var qty = parseInt($input.val()) || 0;
  var inventory = parseInt($invNum.text()) || 0;
  var max = parseInt($input.attr('max')) || inventory;

  if ($(this).hasClass('qtyplus')) {
    if (inventory > 0 && qty < max) {
      qty++;
      inventory--;
    } else {
      flashMax($dataWrap); // let the buyer know they hit available stock
    }
  } else {
    if (qty > 0) {
      qty--;
      inventory++;
    }
  }

  $input.val(qty);
  $invNum.text(inventory);

  // Keep the cell submittable once touched (qty 0 on an in-cart size = removal)
  $(this).closest('.v-table-col-main').addClass('selected');
  syncCellState($dataWrap);
  recalcOrderSummary();

  // Disable plus button if inventory is 0
  if (inventory <= 0) {
    $plusBtn.addClass('disabled').css('pointer-events', 'none').css('opacity', '0.5');
  } else {
    $plusBtn.removeClass('disabled').css('pointer-events', 'auto').css('opacity', '1');
  }
});

  $('.product-detail .v-table-main .quantity-selector').on('input', function(e){
    e.preventDefault();
    var q = $(this).val();
    if(q != 0){
      $(this).closest('.v-table-col-main').addClass('selected');
    }
    else{
      $(this).closest('.v-table-col-main').removeClass('selected');
    }
    syncCellState($(this).closest('.data-wrap'));
    recalcOrderSummary();
  });


  if(localStorage.getItem('hidePrice') == '1'){
    $('body').addClass('no-price');	
    if ($("body").hasClass("no-price")) {
      $('.price-cont').hide();
    }
    else{
      $('.price-cont').show();
    }
    $('.toggle-price i').attr('class','bi bi-eye-slash');
  }
  else{
    $('body').removeClass('no-price');
       if ($("body").hasClass("no-price")) {
      $('.price-cont').hide();
      }
      else{
          $('.price-cont').show();
      }
    $('.toggle-price i').attr('class','bi bi-eye');
  }
  
  // price button in header
  $('.toggle-price').on('click', function(e){
    e.preventDefault();
    var th = $(this);
    if(localStorage.getItem('hidePrice') == '1'){
      if(document.location.href.indexOf('NoPrice') > -1) { // found
        var url = document.location.href.split("NoPrice")[0];
        document.location = url;
      }
      else{
      	// do nothing
      }
      localStorage.setItem('hidePrice', '0');
      $('body').removeClass('no-price');
         if ($("body").hasClass("no-price")) {
      $('.price-cont').hide();
      }
      else{
          $('.price-cont').show();
      }
      $('.toggle-price i').attr('class','bi bi-eye');
    }
    else{
      if(document.location.href.indexOf('NoPrice') > -1) { // found
        // do nothing
      }
      else{
        if(document.location.href.indexOf('?') > -1) {
          var url = document.location.href+"&NoPrice";
          document.location = url;
        }
        else{
          var url = document.location.href+"?NoPrice";
          document.location = url;
        } 
      }
      localStorage.setItem('hidePrice', '1');
      $('body').addClass('no-price');
         if ($("body").hasClass("no-price")) {
      $('.price-cont').hide();
      }
      else{
          $('.price-cont').show();
      }
      $('.toggle-price i').attr('class','bi bi-eye-slash');
    }
  });
  // stacked images
  if($('body').hasClass('template-suffix-marketing')){
    $(".gallery a.open-gallery").fancybox({
      arrows: "true",
      infobar: "true",
      smallBtn: "auto",
      buttons: [
        "zoom",
        //"share",
        "slideShow",
        //"fullScreen",
        //"download",
        "thumbs",
        "close"
      ],
    });
  }
  // mobile footer
  var media = window.matchMedia("(max-width: 767px)");
  if (media.matches) {
    $('#shopify-section-footer ul.section-footer__menu-block__menu > li > a').on('click', function(e){
      e.preventDefault();
      $(this).toggleClass('open');
      //$(this).next('ul.child').slideToggle();
      $(this).next('ul.child').toggleClass('open');
      
    });
  }
  
  var parent = $('.navigation__link.active').attr('data-parent');
  $('.navigation__tier-1 .navigation__link[data-main="'+parent+'"]').addClass('active');
  $('.v-table-main .quantity-selector').on('input', function(){
    var max = Number($(this).attr('max'));
    var v = Number($(this).val());
    console.log(v,max)
    if(v > max){
      $(this).val(max);
    }
  });
  // cart page variant table — one visible row per style; blanks default to 0
  $('.cart-item').each(function(){
    var handle = $(this).attr('data-handle');
    if($('.cart-item[data-handle="'+handle+'"]').length >= 1){
      $('.cart-item[data-handle="'+handle+'"]:not(:first)').hide();
      $('.cart-item[data-handle="'+handle+'"]').find('#cart-variant-table input').each(function(){
        if($(this).val() == ''){
        	$(this).val(0);
        }
      })
      return;
    }

  });

  // ---- AJAX cart editing: no page reload per click. Rapid clicks are batched
  // (700ms debounce) into one /cart/update.js call; totals update in place. ----
  var pendingUpdates = {};
  var cartUpdateTimer = null;

  function applyCartTotals(cart){
    var mf = $('body').attr('data-mf');
    $('.cart-item:visible').each(function(){
      var $row = $(this);
      var pid = String($row.attr('data-product'));
      var units = 0, totalCents = 0;
      cart.items.forEach(function(it){
        if (String(it.product_id) === pid) { units += it.quantity; totalCents += it.final_line_price; }
      });
      $row.find('.cart-item__quantity p').html('<span class="mobile-only">Units:</span>' + units);
      $row.find('.cart-item__total .theme-money').last().text(Shopify.formatMoney(totalCents, mf));
      if (units === 0) { $row.fadeOut(200); }
    });
    $('.limoniapps-discountninja-cart-subtotal-price').text(Shopify.formatMoney(cart.total_price, mf));
    $('.total-unit label').html('Total Units<br>' + cart.item_count);
    if ($('.cart-link__count').length) { $('.cart-link__count').html(cart.item_count); }
    $('.cart-item-list, .checkout-subtotal-container').removeClass('cart-pending');
    if (cart.item_count === 0) { location.reload(); } // let Liquid render the empty-cart state
  }

  function flushCartUpdates(){
    var updates = pendingUpdates;
    pendingUpdates = {};
    $.ajax({ url: '/cart/update.js', type: 'POST', dataType: 'json', data: { updates: updates } })
      .done(applyCartTotals)
      .fail(function(){ location.reload(); }); // fall back to a clean server render on any error
  }

  function queueCartUpdate(variantId, qty){
    pendingUpdates[variantId] = qty;
    $('.cart-item-list, .checkout-subtotal-container').addClass('cart-pending');
    clearTimeout(cartUpdateTimer);
    cartUpdateTimer = setTimeout(flushCartUpdates, 700);
  }

  $(document).on('click', '.cart-item .btnqty', function(e){
    e.preventDefault();
    var $input = $(this).parent('.qtybox').find('.quantity-input');
    var $wrap = $(this).closest('.data-wrap');
    var qty = parseInt($input.val()) || 0;
    var max = parseInt($input.attr('max'));
    if ($(this).hasClass('qtyplus')) {
      if (!isNaN(max) && qty >= max) { flashMax($wrap); return; }
      qty++;
    } else {
      if (qty > 0) { qty--; } else { return; }
    }
    $input.val(qty);
    syncCellState($wrap);
    queueCartUpdate($input.attr('data-variant'), qty);
  });

  $('.remove-item').on('click', function(e){
    e.preventDefault();
    var groupKey = $(this).attr('data-productID');
    var updates = {};
    var $rows = $('.cart-item[data-product="' + groupKey + '"]');
    $rows.each(function(){ updates[$(this).attr('data-variantid')] = 0; });
    $rows.css('opacity', 0.4);
    $.ajax({ url: '/cart/update.js', type: 'POST', dataType: 'json', data: { updates: updates } })
      .done(function(cart){ $rows.remove(); applyCartTotals(cart); })
      .fail(function(){ location.reload(); });
  });
  $('.company-info').on('click', function(e){
    e.preventDefault();
    $(this).find('.company-account').slideToggle();
    $(this).find('i').toggleClass('bi-chevron-up');
  })
}); 

/* Old negative-top form-pull sticky hack removed — the buy zone is now a
   fixed bottom action bar (.buy-action-bar). Tuck it away when the footer
   scrolls into view so it never covers the footer. */
/* RECOVERABILITY GUARD (2026-08-25): on a short PDP the footer is already on
   screen at scroll-top, so the old IntersectionObserver docked the bar on load
   and NO scroll position brought it back — Add to Cart was unreachable. Whether
   it broke depended on viewport HEIGHT (fine at 900px, dead at 1200px). Never
   dock when the trigger is already true at scroll-top. */
$(function(){
  var bar = document.querySelector('.buy-action-bar');
  var footer = document.querySelector('#shopify-section-footer, .footer, footer');
  if (!bar || !footer) return;
  var pending = false;
  function sync(){
    pending = false;
    var limit = window.innerHeight - bar.offsetHeight - 40;
    var rect = footer.getBoundingClientRect();
    if (rect.top + window.scrollY < limit) {
      bar.classList.remove('buy-action-bar--docked');
      return;
    }
    bar.classList.toggle('buy-action-bar--docked', rect.top < limit);
  }
  function onScroll(){ if (!pending) { pending = true; requestAnimationFrame(sync); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  sync();
});

var myMenu = $('.navigation__tier-1').children('li.navigation__item--with-children');
myMenu.on({
  mouseenter: function() { $('.overlay').addClass( "is_hovered" ); },
  mouseleave: function() { $('.overlay').removeClass( "is_hovered" ); }
});

$('.navigation__tier-3 li.navigation__item').hover(function(){
    var parent = $(this).find('a').data('parent');
    var get_main =  $('.navigation__tier-1 li').find('[data-main="' + parent + '"]');
    $('.navigation__tier-1 li').removeClass('navigation__item--active');
   $(get_main).closest('li').addClass('navigation__item--active');
});

// if($("#NavigationTier2-1:hover").length != 0){
//             console.log("yes-in");
//         } else{
//             console.log("yes-out");
//         }

// var video_container = $('.video-container').eq(0);

// $(document).on('click',video_container,function(){
//   $('.altcolours')[0].click()
// });

var video_container = $('.video-container').eq(0);
$(video_container).click(function(){
   $('.altcolours')[0].click()
})

$(window).on('load', function(){
  $('.product-list .block-inner .product-block__title').matchHeight();
});

let interval = null;

// let domWorks = () => {
//      let d = document.querySelector('.template-product .price-container')
//      if(d){
//       $('.template-product .price-container .current-price').addClass('hide')
//       clearInterval(interval) // Change it via reference
//      }
// }

// interval = setInterval(domWorks, 100)
document.addEventListener('DOMContentLoaded', function () {
  const productCards = document.querySelectorAll('.product-list .product-block');

  productCards.forEach(function (card) {
    const brand = card.getAttribute('data-product-brand');
    const rawSku = card.getAttribute('data-product-sku');
    let formattedSku = '';

    if (rawSku) {
      if (brand && brand.toLowerCase() === 'deke') {
        const parts = rawSku.split(" ").filter(Boolean);
        formattedSku = parts.length > 1 ? parts[0] + '-' + parts[1] : parts[0] || '';
      } else {
        formattedSku = rawSku.split(" ")[0];
      }
    }

    const skuElement = card.querySelector('.sku__value');
    if (skuElement) {
      skuElement.innerHTML = '' + formattedSku;
    }
  });
});
document.addEventListener('variant:change', function(event) {
  var variant = event.detail.variant;
  if (variant) {
    document.querySelector('#selected-inseam').value = variant.option3; // assuming option2 is inseam
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const el = document.querySelector(
    '.clickyboxes.options--in-seam a[data-value="34"]'
  );
  if (el) {
    el.classList.remove("unavailable"); // optional
    el.click();
  }
});
